export class CardBrandFull {
  code: string;
  description: string;

  constructor() {
    this.code = '';
    this.description = '';
  }
}
